import Layout from "../Layout";
import GeneralHeader from "../../components/GeneralHeader";
import Footer from "../../components/Footer";
import ProfileContainer from "../../containers/ProfileContainer";

const ProfilePage = () => {
  return (
    <Layout
      header={<GeneralHeader />}
      center={<ProfileContainer />}
      footer={<Footer />}
    />
  )
}

export default ProfilePage;